/**
 * Labels principales de formularios cliente (ultrasound, massage, DNA).
 * Errores de envío/validación permanecen en inglés en los componentes.
 */

const shared = {
  en: {
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    spousePartner: "Spouse - Partner Name:",
    addressLine1: "Address line 1",
    addressLine2: "Address line 2",
    city: "City",
    state: "State",
    zipCode: "Zip Code",
    phoneCel: "Phone - Cel",
    dateOfBirth: "Your Date of Birth",
    physicianName: "Phisician Name",
    physicianPhone: "Phisician Phone",
    doctorFacilities:
      "Have you informed your doctor of your visit to our facilities?",
    pregnancyProblem:
      "Have you had any problem with your current pregnacy?",
    ifYesExplain: "If Yes, please explain:",
    aboutUs: "How did your hear about us?",
    selectAnOption: "Select an option",
    yes: "Yes",
    no: "No",
    termsAndConditions: "Terms and conditions",
    waiver: "Waiver",
    agreeTermsUse: "I agree with the terms of use",
    agreeWaiver: "I agree with the waiver conditions",
    babyAcademyIntro:
      "I would like to learn more about The Baby Academy\u2019s live online classes for pregnant women, provided directly through insurance. These clinician-led classes cover birth & breastfeeding, newborn safety (including choking), and recovery after birth. I understand that by checking this box, my information will be shared with The Baby Academy.",
    babyAcademyYes:
      "Yes, I\u2019d like The Baby Academy to contact me about accessing pregnancy & newborn classes provided through insurance",
    babyAcademyNo: "No thanks",
    formHeaderWelcome: "Welcome",
    formHeaderToSite: "to Little Bellies",
    formHeaderAppointment: "You have an appointment for",
    formHeaderRequiredServices: "Your required services are:",
    formHeaderFillForm: "Please fill the following form:",
  },
  es: {
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    spousePartner: "Esposo - Conyugue:",
    addressLine1: "Dirección línea 1",
    addressLine2: "Dirección línea 2",
    city: "Ciudad",
    state: "Estado",
    zipCode: "Código postal",
    phoneCel: "Teléfono de celular",
    dateOfBirth: "Su Fecha de nacimiento",
    physicianName: "Médico",
    physicianPhone: "Teléfono de médico",
    doctorFacilities:
      "¿Ha informado a su médico de su visita a nuestras instalaciones?",
    pregnancyProblem:
      "¿Has tenido algún problema con tu embarazo actual?",
    ifYesExplain: "En caso afirmativo, por favor explique:",
    aboutUs: "¿Como supiste de nosotros?",
    selectAnOption: "Selecciona una opción",
    yes: "Sí",
    no: "No",
    termsAndConditions: "Términos y condiciones",
    waiver: "Exención de responsabilidad",
    agreeTermsUse: "Estoy de acuerdo con los términos de uso",
    agreeWaiver: "Acepto las condiciones de la exención de responsabilidad",
    babyAcademyIntro:
      "Quiero aprender más sobre las clases en línea de The Baby Academy, facturadas directamente a través de la aseguradora. Estas clases guiadas por profesionales cubren parto y lactancia, seguridad del recién nacido (incluyendo la deglución) y recuperación después del parto. Entiendo que al marcar esta casilla, mi información será compartida con The Baby Academy.",
    babyAcademyYes:
      "Sí, me gustaría que The Baby Academy me contactara sobre el acceso a las clases de embarazo y parto y lactancia, proporcionadas directamente a través de la aseguradora.",
    babyAcademyNo: "No, gracias",
    formHeaderWelcome: "Bienvenido",
    formHeaderToSite: "a Little Bellies",
    formHeaderAppointment: "Tienes una cita para",
    formHeaderRequiredServices: "Tus servicios requeridos son:",
    formHeaderFillForm: "Por favor completa el siguiente formulario:",
  },
};

const ultrasound = {
  en: {
    dueDate: "Due Date",
    howManyUltrasounds:
      "How many ultrasounds have you taken with this pregnancy?",
    lastUltrasound: "When was the last ultrasound?",
    resultsNormal: "Were the results normal?",
    ifAbnormalExplain: "if abnormal, please explain",
  },
  es: {
    dueDate: "Fecha de parto",
    howManyUltrasounds:
      "¿Cuántas ecografías se ha tomado con este embarazo?",
    lastUltrasound: "¿Cuándo fue tu última ecografía?",
    resultsNormal: "¿Los resultados fueron normales?",
    ifAbnormalExplain: "Si es anormal, por favor explique",
  },
};

const massage = {
  en: {
    howManyMassages:
      "How many massages have you had with this current pregnancy?",
    lastMassage: "When was your last massage?",
    anyProblems: "Were there any problems?",
    ifProblemsExplain: "If problems, please explain",
  },
  es: {
    howManyMassages:
      "¿Cuantos masajes has tenido con este embarazo actual?",
    lastMassage: "¿Cuándo fue tu último masaje?",
    anyProblems: "¿Hubo algún problema?",
    ifProblemsExplain: "Si hay problemas, por favor explique",
  },
};

export const CLIENT_FORM_TYPES = ["ultrasound", "massage", "dna"];

export const CLIENT_FORM_TYPE = {
  ULTRASOUND: "ultrasound",
  MASSAGE: "massage",
  DNA: "dna",
};

/** @param {"ultrasound"|"massage"|"dna"} formType @param {"en"|"es"} lang */
export function getClientFormCopy(formType, lang) {
  const base = { ...shared[lang] };
  if (formType === CLIENT_FORM_TYPE.ULTRASOUND) {
    return { ...base, ...ultrasound[lang] };
  }
  if (formType === CLIENT_FORM_TYPE.MASSAGE) {
    return { ...base, ...massage[lang] };
  }
  return base;
}

export default getClientFormCopy;
